import PropTypes from "prop-types";
import React, { Fragment } from "react";
import {isMobileOnly, isTablet} from "react-device-detect";
import Countdown from "react-countdown";

const ForecastsSingleTwo = ({
                                forecast,
                                currency,
                                sliderClassName,
                                spaceBottomClass,
                                colorClass,
                                titlePriceClass, isSide, index
                              }) => {

   // Renderer callback with condition
   const renderer = ({ days, hours, minutes, seconds, completed }) => {
    return <span style={{color: "grey", fontWeight: 500, fontSize: "11px"}}>Se termine dans {days}j {hours}h {minutes}mn</span>;
  };

  const rendererSoon = ({ days, hours, minutes, seconds, completed }) => {
    return <span style={{color: "grey", fontWeight: 500, fontSize: "11px"}}>Commence dans {days}j {hours}h {minutes}mn</span>;
  };

  return (
      <Fragment>
        <div
            className={isSide ? `col-xl-3 col-md-3 col-lg-3 col-sm-3 ${
                sliderClassName ? sliderClassName : ""
            }` : `col-xl-2 col-md-3 col-lg-3 col-sm-3 ${
                sliderClassName ? sliderClassName : ""
            }`}
            style={{width: isMobileOnly ? "120px !important" : "230px !important", marginLeft: index == 0 && !isMobileOnly && isSide ? "-15px" : ""}}

        >
          <div
              style={{width: isMobileOnly ? "120px !important" : "230px !important", marginLeft: index == 0 && !isMobileOnly && isSide ? "-15px" : ""}}
              className={`sales-wrap-2 ${
                  spaceBottomClass ? spaceBottomClass : ""
              } ${colorClass ? colorClass : ""} `}
          >
            <div className="product-img" style={{backgroundColor: "white", width: isMobileOnly ? "120px !important" : "230px !important", textAlign: "center", height: isMobileOnly ? "120px !important" : "230px !important", overflow: "hidden"}}>
              <a href={process.env.PUBLIC_URL + "/forecast/" + forecast.id}>
                <img
                    className="default-img"
                    src={(forecast.cover != "" ? forecast.desktopCover : "")}
                    alt={forecast.name + " au meilleur prix !"}
                    style={{height: "100%"}}
                />
              </a>
              

              {forecast.availableSoon ? (
                  <div className="product-img-badges">
                    <span className="purple" style={{backgroundColor : 'red', color : 'white'}}>Bientôt disponible</span>
                  </div>
              ) : (
                  ""
              )}

            </div>
            <div className="product-content-2">
              <div
                  className={`title-price-wrap-2 ${
                      titlePriceClass ? titlePriceClass : ""
                  }`}
              >
                <div className="price-2">
                  <h3 style={{lineHeight: "13px", fontSize: "16px"}}>
                  <a href={forecast.redirectLink} target="_blank">
                      {forecast.name}
                    </a>
                  </h3>
                  <div style={{lineHeight: "15px", marginTop: "5px"}}>
                    <a href={forecast.redirectLink} target="_blank">
                      <span style={{color: "grey", fontWeight: 500, fontSize: "11px"}}>{forecast.description}</span>
                    </a>
                  </div>
                  <div style={{lineHeight: "15px", marginTop: "5px"}}>
                    <a href={forecast.redirectLink} target="_blank">
                      <span style={{color: "grey", fontWeight: 500, fontSize: "11px"}}>
                        {
                          forecast.availableSoon ? 
                          <Countdown date={forecast.beginDate} renderer={rendererSoon}></Countdown>:
                                                   <Countdown date={forecast.endDate} renderer={renderer}></Countdown>
                        }
                        </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
  );
};

ForecastsSingleTwo.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItem: PropTypes.object,
  compareItem: PropTypes.object,
  currency: PropTypes.object,
  forecast: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  titlePriceClass: PropTypes.string,
  wishlistItem: PropTypes.object
};

export default ForecastsSingleTwo;
